<ng-container *ngIf="agreement">
  <div class="add-padding-bottom add-margin-bottom">
    <apex-page-info>
      <T
        title
        str="Agreement"></T>
    </apex-page-info>

    <h2 class="am">
      <ng-container *ngIf="agreement.id">
        {{ agreement.name }}
      </ng-container>
    </h2>

    <form>
      <div class="df c apl apt am mat-elevation-z2">
        <mat-form-field class="amr">
          <input
            matInput
            type="text"
            name="name"
            [value]="agreement.name"
            [placeholder]="'Name' | translate"
            readonly />
        </mat-form-field>

        <mat-form-field class="amr">
          <textarea
            matInput
            name="description"
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="10"
            [placeholder]="'Description' | translate"
            [value]="agreement.description"
            readonly>
          </textarea>
        </mat-form-field>

        <div class="df ac">
          <mat-form-field class="f1 amr">
            <mat-label>
              <T str="Period"></T>
            </mat-label>
            <mat-date-range-input
              [rangePicker]="picker"
              required>
              <input
                matStartDate
                name="from"
                [value]="agreement.from"
                [placeholder]="'Start date' | translate"
                readonly />
              <input
                matEndDate
                name="to"
                [value]="agreement.to"
                [placeholder]="'End date' | translate"
                readonly />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
              disabled>
            </mat-datepicker-toggle>
            <mat-date-range-picker
              #picker
              disabled="true"></mat-date-range-picker>
          </mat-form-field>

          <mat-checkbox
            class="amr"
            name="active"
            [checked]="agreement.active"
            (click)="$event.preventDefault()">
            <T str="Active"></T>
          </mat-checkbox>
        </div>

        <mat-checkbox
          class="amr amb"
          name="requireReports"
          [checked]="agreement.requireReports"
          (click)="$event.preventDefault()">
          <T str="Require an uploaded report to close the case"></T>
        </mat-checkbox>
      </div>
    </form>

    <!-- Cases for this agreement -->
    <apex-case-list [cases]="cases"></apex-case-list>

    <div class="df w aml">
      <!-- left -->
      <div class="df c f1 amr">
        <apex-file-usage
          [disabled]="true"
          class="amb"
          view="List"
          [title]="'Public Files' | translate"
          [description]="'Will be shared with clients' | translate"
          self="agreement"
          [selfId]="agreement.id || 0"
          name="public-files">
        </apex-file-usage>

        <div
          class="amb"
          *ngIf="agreement.id">
          <apex-model-role
            [disabled]="true"
            model="agreement"
            [modelId]="agreement.id"
            role="involved"
            [label]="'Involved' | translate"
            [title]="'Involved' | translate">
          </apex-model-role>
        </div>
      </div>

      <!-- right -->
      <div
        class="df c f1 amr"
        *ngIf="agreement.id">
        <apex-text-usage
          [ngClass]="{ 'pointer-events-disable': true }"
          class="amb"
          [label]="'External Information' | translate"
          model="agreement"
          [modelId]="agreement.id"
          name="external-information">
        </apex-text-usage>

        <apex-object-fields
          *ngIf="agreement.ObjectId"
          [disabled]="true"
          [objectId]="Number(agreement.ObjectId)"
          [agreementId]="agreement.id"></apex-object-fields>
      </div>
    </div>
  </div>
</ng-container>

<!-- Loading State -->
<div
  *ngIf="loading"
  class="df jc ac apl apt am">
  <p>
    <T str="Loading..."></T>
  </p>
</div>

<!-- Error State -->
<div
  *ngIf="!loading && error"
  class="df jc ac apl apt am">
  <p class="error-text">{{ error }}</p>
</div>
